module.exports = __webpack_public_path__ + "static/media/sgd.static.de46abd6.svg";